import { useContext } from "react";
import SelectableMessageTableMessagesContext from "views/components/widgets/SelectableMessageTableMessagesContext";
const useSelectableLogViewMessages = () => {
  const contextValue = useContext(SelectableMessageTableMessagesContext);
  if (!contextValue) {
    throw new Error(
      "useSelectableLogViewMessages hook needs to be used inside SelectableMessageTableMessagesContext.Provider"
    );
  }
  return {
    selectableLogViewMessages: contextValue == null ? void 0 : contextValue.selectableMessageTableMessages
  };
};
export default useSelectableLogViewMessages;
